(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sp-back-to-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sp-back-to-top')) {
    customElements.define(
      'sp-back-to-top',
      class SpBackToTop extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-sp-totop-button]');
          if (!this.button) return;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.button.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: this.reduced ? 'auto' : 'smooth' });
            const target = document.getElementById('MainContent') || document.body;
            target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
          });
          this.ticking = false;
          this.onScroll = () => {
            if (this.ticking) return;
            this.ticking = true;
            window.requestAnimationFrame(() => {
              this.ticking = false;
              // show after roughly two screens; lift above a sticky bar (product add-to-cart or
              // article product bar) while one is visible
              this.hidden = window.scrollY < window.innerHeight * 2;
              const bar = document.querySelector('[data-sp-sticky]:not([hidden]), [data-sp-article-bar]:not([hidden])');
              this.classList.toggle('sp-totop--lifted', !!bar);
              if (bar) this.style.setProperty('--sp-totop-lift', bar.offsetHeight + 12 + 'px');
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.onScroll();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sp-buy-accordion"] && !Shopify.designMode) return;
  try {
    // "N-day happiness guarantee" in the trust row: open the guarantee row and bring the
  // accordion to the middle of the screen instead of jumping to an anchor.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#sp-guarantee"]');
    if (!link) return;
    const box = document.getElementById('sp-guarantee');
    const row = box && box.querySelector('[data-sp-guarantee-row]');
    if (!row) return;
    event.preventDefault();
    row.open = true;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    box.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
    row.querySelector('summary').focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sp-buy-kits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sp-buy-kits')) {
    customElements.define(
      'sp-buy-kits',
      class SpBuyKits extends HTMLElement {
        connectedCallback() {
          if (this.dataset.spReady) return;
          this.dataset.spReady = '1';
          const raw = this.querySelector('[data-sp-kits-data]');
          if (!raw) return;
          this.data = JSON.parse(raw.textContent);
          this.fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: this.data.currency });
          this.busy = false;
          this.info = this.closest('product-info');
          this.currentVariantId = this.variantFor(1)?.id ?? null;

          this.onChange = (e) => {
            if (!e.target.matches('[data-sp-kit], [data-sp-row-opt]')) return;
            this.update();
            if (e.target.matches('[data-sp-row-opt^="1-"]')) this.syncProduct();
          };
          this.onClick = (e) => {
            const unlock = e.target.closest('[data-sp-gift-unlock]');
            if (unlock) {
              this.unlock(Number(unlock.dataset.spGiftUnlock), unlock.closest('[data-sp-gift-tier]'));
              return;
            }
            if (e.target.closest('[data-sp-kits-add]')) this.add();
          };
          this.addEventListener('change', this.onChange);
          this.addEventListener('click', this.onClick);
          this.update();
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onChange);
          this.removeEventListener('click', this.onClick);
          this.abortController?.abort();
        }

        kit() {
          const checked = this.querySelector('[data-sp-kit]:checked');
          return checked ? Number(checked.value) : 1;
        }

        kitNameFor(tier) {
          return this.querySelector(`[data-sp-kit="${tier}"]`)?.dataset.spKitName || '';
        }

        kitName() {
          return this.kitNameFor(this.kit());
        }

        unlock(tier, tile) {
          if (tier <= this.kit()) return;
          const radio = this.querySelector(`[data-sp-kit="${tier}"]`);
          if (!radio) return;
          const reveal = () => {
            radio.checked = true;
            this.update();
            this.querySelectorAll('[data-sp-gift-tier]').forEach((t) => {
              const n = Number(t.dataset.spGiftTier);
              if (n > 1 && n <= tier && t.classList.contains('is-on') && !t.dataset.spRevealed) {
                t.dataset.spRevealed = '1';
                this.burst(t);
              }
            });
          };
          if (tile && !tile.classList.contains('is-on') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            tile.classList.add('is-shake');
            setTimeout(() => {
              tile.classList.remove('is-shake');
              reveal();
            }, 380);
          } else {
            reveal();
          }
        }

        burst(tile) {
          const box = tile.querySelector('.sp-kits__gift-burst');
          if (box) {
            box.innerHTML = '';
            for (let i = 0; i < 10; i++) {
              const dot = document.createElement('i');
              const a = (Math.PI * 2 * i) / 10;
              dot.style.setProperty('--x', `${Math.round(Math.cos(a) * 46)}px`);
              dot.style.setProperty('--y', `${Math.round(Math.sin(a) * 46)}px`);
              box.appendChild(dot);
            }
          }
          tile.classList.add('is-pop');
          setTimeout(() => {
            tile.classList.remove('is-pop');
            if (box) box.innerHTML = '';
          }, 800);
        }

        variantFor(row) {
          const optCount = this.data.variants[0].options.length;
          const picked = [];
          for (let o = 0; o < optCount; o++) {
            const input = this.querySelector(`[data-sp-row-opt="${row}-${o}"]:checked`);
            picked.push(input ? input.value : null);
          }
          return this.data.variants.find((v) => v.options.every((val, i) => val === picked[i])) || null;
        }

        money(cents) {
          return this.fmt.format(cents / 100);
        }

        update() {
          const n = this.kit();
          this.querySelectorAll('[data-sp-row]').forEach((row) => {
            row.hidden = Number(row.dataset.spRow) > n;
          });

          // every kit is priced from its own rows (hidden rows keep their picks), so switching kits never changes a number;
          // the saving is floored like Dawn's price badge, so the card and the price under the title agree
          const rows = [1, 2, 3].map((r) => this.variantFor(r));
          const picks = rows.slice(0, n);
          const giftC = this.data.gift ? this.data.gift.compare * this.data.giftQty : 0;
          const bonusC = this.data.bonus ? this.data.bonus.compare : 0;
          const totals = {};
          for (let k = 1; k <= 3; k++) {
            const list = rows.slice(0, k);
            if (list.some((v) => !v)) continue;
            const price = list.reduce((s, v) => s + v.price, 0);
            const itemsCompare = list.reduce((s, v) => s + v.compare, 0);
            let compare = itemsCompare;
            if (k >= 2) compare += giftC;
            if (k >= 3) compare += bonusC;
            totals[k] = { price, compare, itemsCompare, gifts: compare - itemsCompare };
            const p = this.querySelector(`[data-sp-kit-price="${k}"]`);
            const c = this.querySelector(`[data-sp-kit-compare="${k}"]`);
            const s = this.querySelector(`[data-sp-kit-save="${k}"]`);
            if (p) p.textContent = this.money(price);
            if (c) c.textContent = this.money(compare);
            if (s) s.textContent = this.dataset.spSaveLabel.replace('[percent]', Math.floor(((compare - price) * 100) / compare));
          }

          for (let r = 1; r <= 3; r++) {
            const label = this.querySelector(`[data-sp-row-color="${r}"]`);
            const v = this.variantFor(r);
            if (label) label.textContent = v && this.data.colorIndex > -1 ? v.options[this.data.colorIndex] : '';
          }

          this.querySelectorAll('[data-sp-gift-tier]').forEach((tile) => {
            const tier = Number(tile.dataset.spGiftTier);
            const on = tier <= n;
            tile.classList.toggle('is-on', on);
            if (!on) delete tile.dataset.spRevealed;
            tile.querySelectorAll('[data-sp-when-on]').forEach((el) => (el.hidden = !on));
            tile.querySelectorAll('[data-sp-when-off]').forEach((el) => (el.hidden = on));
            const lock = tile.querySelector('[data-sp-tap-label]');
            if (lock) lock.textContent = this.dataset.spTapLabel.replace('[kit]', this.kitNameFor(tier));
            const btn = tile.querySelector('[data-sp-gift-unlock]');
            if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          const progress = this.querySelector('[data-sp-progress]');
          if (progress) progress.textContent = this.dataset.spUnlockedLabel.replace('[unlocked]', n);

          const allAvailable = picks.every((v) => v && v.available);
          const t = totals[n];
          const total = t ? this.money(t.price) : '';
          const addText = this.querySelector('[data-sp-add-text]');
          const main = this.querySelector('[data-sp-kits-add]');
          if (addText) {
            addText.textContent = allAvailable
              ? this.dataset.spAddLabel.replace('[price]', total)
              : this.dataset.spSoldoutLabel;
          }
          if (main) main.disabled = !allAvailable;

          this.renderSaving(t, n);

          // the sticky bar reads `state` when it connects and listens for the event after that
          this.state = {
            name: this.kitName(),
            price: t ? t.price : null,
            priceText: total,
            savePercent: t && t.compare > t.price ? Math.floor(((t.compare - t.price) * 100) / t.compare) : 0,
            available: allAvailable,
          };
          this.dispatchEvent(new CustomEvent('sp-kits:change', { bubbles: true, detail: this.state }));
        }

        // "You save $X" = compare-at saving on the items + the value of the free gifts; shipping and the guarantee are listed, not counted
        renderSaving(t, n) {
          const box = this.querySelector('[data-sp-saving]');
          const totalEl = this.querySelector('[data-sp-saving-total]');
          const list = this.querySelector('[data-sp-saving-list]');
          if (!box || !totalEl || !list) return;
          if (!t) {
            box.hidden = true;
            return;
          }
          const itemsSaving = Math.max(0, t.itemsCompare - t.price);
          const total = itemsSaving + t.gifts;
          if (total <= 0) {
            box.hidden = true;
            return;
          }
          const items = [];
          if (itemsSaving > 0) {
            items.push(
              this.dataset.spSavingItemsLabel
                .replace('[compare]', this.money(t.itemsCompare))
                .replace('[price]', this.money(t.price))
                .replace('[amount]', this.money(itemsSaving))
            );
          }
          if (t.gifts > 0) {
            const names = [];
            if (n >= 2 && this.data.gift) names.push(`${this.data.giftQty} × ${this.data.giftLabel}`);
            if (n >= 3 && this.data.bonus) names.push(this.data.bonusLabel);
            items.push(this.dataset.spSavingGiftsLabel.replace('[gifts]', names.join(' + ')).replace('[amount]', this.money(t.gifts)));
          }
          items.push(this.dataset.spSavingShippingLabel);
          totalEl.textContent = this.money(total);
          list.replaceChildren(
            ...items.map((text) => {
              const li = document.createElement('li');
              li.textContent = text;
              return li;
            })
          );
          box.hidden = false;
        }

        // item 1 is the product the page is about: fetch the section for its variant and let Dawn's product-info
        // swap the price block, the gallery image and the URL, exactly as its own variant picker would
        syncProduct() {
          const v = this.variantFor(1);
          if (!v || v.id === this.currentVariantId || !this.info) return;
          this.currentVariantId = v.id;
          this.abortController?.abort();
          this.abortController = new AbortController();
          const section = this.dataset.spSection;
          const url = this.dataset.spUrl;
          fetch(`${url}?variant=${v.id}&section_id=${section}`, { signal: this.abortController.signal })
            .then((res) => res.text())
            .then((text) => {
              if (v.id !== this.currentVariantId) return;
              const html = new DOMParser().parseFromString(text, 'text/html');
              const source = html.getElementById(`price-${section}`);
              const destination = this.info.querySelector(`#price-${section}`);
              if (source && destination) destination.innerHTML = source.innerHTML;
              this.info.updateMedia?.(html, v.media);
              this.info.updateURL?.(url, v.id);
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.variantChange, {
                  data: { sectionId: section, html, variant: { id: v.id, featured_media: v.media ? { id: v.media } : null } },
                });
              }
            })
            .catch((error) => {
              if (error.name !== 'AbortError') console.error(error);
            });
        }

        items() {
          const n = this.kit();
          const byId = new Map();
          for (let r = 1; r <= n; r++) {
            const v = this.variantFor(r);
            if (!v) return null;
            byId.set(v.id, (byId.get(v.id) || 0) + 1);
          }
          const items = [...byId].map(([id, quantity]) => ({ id, quantity }));
          if (n >= 2 && this.data.gift && this.data.gift.available) items.push({ id: this.data.gift.id, quantity: this.data.giftQty });
          if (n >= 3 && this.data.bonus && this.data.bonus.available) items.push({ id: this.data.bonus.id, quantity: 1 });
          return items;
        }

        setBusy(on) {
          this.busy = on;
          const main = this.querySelector('[data-sp-kits-add]');
          if (main) main.setAttribute('aria-busy', on ? 'true' : 'false');
          const addText = this.querySelector('[data-sp-add-text]');
          if (on && addText) addText.textContent = this.dataset.spAddingLabel;
          if (!on) this.update();
        }

        async add() {
          if (this.busy) return;
          const items = this.items();
          const error = this.querySelector('[data-sp-error]');
          if (!items) return;
          error.hidden = true;
          this.setBusy(true);
          const drawer = document.querySelector('cart-drawer');
          const body = { items };
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            body.sections = drawer.getSectionsToRender().map((s) => s.id);
            body.sections_url = window.location.pathname;
            drawer.setActiveElement?.(document.activeElement);
          }
          const failsafe = setTimeout(() => this.setBusy(false), 15000);
          try {
            const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify(body),
            });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || data.message || 'add failed');
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sp-buy-kits', cartData: data });
            }
            if (drawer && data.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
            } else {
              window.location.href = window.routes?.cart_url || '/cart';
            }
          } catch (e) {
            error.textContent = this.dataset.spErrorLabel;
            error.hidden = false;
          } finally {
            clearTimeout(failsafe);
            this.setBusy(false);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sp-cart-clear"] && !Shopify.designMode) return;
  try {
    /*
    <sp-cart-clear>: the "Clear cart" link in the cart drawer header (this snippet).

    One tap sends one POST /cart/clear.js with bundled sections (cart-drawer, cart-icon-bubble)
    and repaints the drawer from that response the way Dawn's own CartItems does when the last
    line is removed: `is-empty` on <cart-drawer>, .drawer__inner and the header bubble replaced,
    focus moved into the empty state. Then PUB_SUB_EVENTS.cartUpdate is published with source
    'cart-items', which in Dawn means "the drawer is already rendered from this state, don't
    fetch it again".

    Races: while the clear runs, <cart-drawer> carries `is-clearing` (items and footer ignore
    taps) so no other cart request can start; if Dawn's quantity change, the discount box or a
    cross-sell add is already in flight, the clear waits for it (3 s cap) so a late response
    cannot repaint a cart that was just emptied. A failed request shows an error and leaves the
    cart as it was. If Shopify ever answers without sections, the page reloads so the drawer
    never shows a stale cart.
  */
  (() => {
    const config = () =>
      typeof fetchConfig === 'function'
        ? fetchConfig()
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    // Dawn's quantity change, the discount box, a cross-sell product-form: their in-flight markers
    const IN_FLIGHT = '.cart__items--disabled, [aria-busy="true"], button.loading';
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    class SpCartClear extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('[data-sp-clear]');
        this.error = this.querySelector('[data-sp-clear-error]');
        if (!this.link) return;
        this.link.addEventListener('click', () => this.clear());
      }

      get busy() {
        return this.getAttribute('aria-busy') === 'true';
      }

      // a drawer re-render (Dawn's, the discount box's) can detach this element mid-wait; the drawer itself stays
      get drawer() {
        return this.closest('cart-drawer') || document.querySelector('cart-drawer');
      }

      set busy(value) {
        this.setAttribute('aria-busy', value ? 'true' : 'false');
        this.link.disabled = !!value;
        const drawer = this.drawer;
        if (drawer) drawer.classList.toggle('is-clearing', !!value);
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = false;
      }

      hideError() {
        if (!this.error) return;
        this.error.hidden = true;
        this.error.textContent = '';
      }

      otherRequestRunning() {
        const drawer = this.drawer;
        if (!drawer) return false;
        if (Array.from(drawer.querySelectorAll(IN_FLIGHT)).some((el) => el !== this && !this.contains(el))) return true;
        // a quantity change Dawn has not sent yet (it debounces the change event 300 ms): the input already
        // shows the new value while data-cart-quantity still holds what the cart has
        return Array.from(drawer.querySelectorAll('.quantity__input[data-cart-quantity]')).some(
          (input) => input.dataset.cartQuantity !== '' && Number(input.value) !== Number(input.dataset.cartQuantity)
        );
      }

      async clear() {
        if (this.busy) return;
        this.busy = true;
        this.hideError();
        try {
          for (let waited = 0; waited < 3000 && this.otherRequestRunning(); waited += 100) await sleep(100);
          const body = JSON.stringify({ sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname });
          const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
          const response = await fetch(`${cartUrl}/clear.js`, { ...config(), body });
          const cart = await response.json();
          if (!response.ok || cart.status) throw new Error(cart.description || cart.message || 'cart clear failed');
          this.render(cart);
        } catch (error) {
          this.busy = false;
          this.showError(this.dataset.msgError || 'Something went wrong. Please try again.');
        }
      }

      // mirrors the empty-cart branch of CartItems.updateQuantity in assets/cart.js
      render(cart) {
        const drawer = document.querySelector('cart-drawer');
        const drawerHtml = cart.sections && cart.sections['cart-drawer'];
        if (!drawer || !drawerHtml) {
          window.location.reload();
          return;
        }
        const parse = (text, selector) => new DOMParser().parseFromString(text, 'text/html').querySelector(selector);
        const empty = cart.item_count === 0;
        drawer.classList.toggle('is-empty', empty);
        const inner = drawer.querySelector('.drawer__inner');
        const nextInner = parse(drawerHtml, '.drawer__inner');
        if (inner && nextInner) inner.innerHTML = nextInner.innerHTML; // this element goes with the old markup
        drawer.classList.remove('is-clearing');
        const bubble = document.getElementById('cart-icon-bubble');
        const nextBubble = cart.sections['cart-icon-bubble'] && parse(cart.sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && nextBubble) bubble.innerHTML = nextBubble.innerHTML;
        const emptyState = drawer.querySelector('.drawer__inner-empty');
        if (typeof trapFocus === 'function' && emptyState) trapFocus(emptyState, drawer.querySelector('a'));
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
        }
      }
    }

    if (!customElements.get('sp-cart-clear')) customElements.define('sp-cart-clear', SpCartClear);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sp-header-menu"] && !Shopify.designMode) return;
  try {
    // Groups inside the drawer open and close instantly. Dawn's own summary
  // handler (100ms delay on open, animated close, focus trap into the group)
  // is bypassed for groups; the main hamburger toggle still goes through Dawn.
  document.querySelectorAll('header-drawer').forEach((drawer) => {
    drawer.addEventListener(
      'click',
      (event) => {
        const summary = event.target.closest('summary');
        if (!summary || !drawer.contains(summary)) return;
        const details = summary.parentElement;
        if (details === drawer.mainDetailsToggle) return;
        event.preventDefault();
        event.stopPropagation();
        const willOpen = !details.open;
        details.open = willOpen;
        summary.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      },
      true
    );
  });
  } catch(e) { console.error(e); }
})();

})();
